var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-report',{attrs:{"renderBackAndForthFooter":false,"isProgressDone":true,"showFooter":false}},[_c('sign-up-card',{attrs:{"logo":_vm.setLogo,"title":_vm.title,"text":_vm.text,"isDescriptionCardActive":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }